import { render, staticRenderFns } from "./HR.vue?vue&type=template&id=f96891f4&"
import script from "./HR.vue?vue&type=script&lang=js&"
export * from "./HR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports